import React, { useEffect } from "react";
import "../style/about.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import about1 from "../image/about1.webp";
import about2 from "../image/about2.webp";
import about3 from "../image/about3.webp";
import about from "../image/about.webp";
import row3 from "../image/row3.webp";
import row4_1 from "../image/row4-1.webp";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="relative h-screen">
        <img src={about} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 z-20 flex h-full w-full flex-col justify-center bg-black/10 p-20 text-center text-white">
          <p className="text-[80px] font-bold tracking-[4px]">
            Visit the Workshop
          </p>
          <p className="leading-6">
            From full hide to finished good, it all happens under this roof in{" "}
            <br />
            Laramie. Step inside to feel the leather, see the process, and leave{" "}
            <br />
            with a piece that already knows your name.
          </p>
        </div>
      </div>
      <div className="relative my-10 h-screen">
        <img src={about1} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 z-20 flex h-full w-full flex-col justify-center bg-black/10 p-20 text-white">
          <p className="text-[80px] font-bold tracking-[4px]">
            Made by hand. <br />
            Made to last.
          </p>
          <p className="leading-6">
            Every Elviroxab leather good starts as a full hide of Horween
            leather <br />
            and ends as something meant to outlive the trends. Our crafters work{" "}
            <br />
            with the same techniques used a century ago — because some things{" "}
            <br />
            don't need improving, just patience.
          </p>
        </div>
      </div>
      <div className="relative my-10 h-screen">
        <img src={about2} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 z-20 flex h-full w-full flex-col justify-center bg-black/10 p-20 text-center text-white">
          <p className="leading-6">
            America was built upon sojourning tradesmen who carried their skills{" "}
            <br />
            from around the world to live and work in a country where "In God We{" "}
            <br />
            Trust." Adam was instructed to work hard and subdue the land. The{" "}
            <br />
            apostle Paul encouraged those in Thessalonica to "aspire to live{" "}
            <br />
            quietly, and to mind your own affairs, and to work with your hands."{" "}
            <br />
            We believe that working with your hands is a respectable trade, so{" "}
            <br />
            that's what we do.
          </p>
        </div>
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default About;
